import {
  AI_DELIVERY_STATUS,
  AI_JOB_STATUS,
  isAiJobMisdelivered,
  type AiTestJob,
} from '@kitobxonlik/contracts';

/**
 * AI so'rovining holati — kitob savollari paneli va har sahifadagi AI
 * jarayonlari oynasi uchun umumiy (2026-10-30).
 */

/** AI hali ishlayapti (navbatda yoki tahlilda) — savollar kelmagan */
export function isAiJobRunning(job: AiTestJob): boolean {
  return (
    !job.received_at &&
    (job.status === AI_JOB_STATUS.QUEUED || job.status === AI_JOB_STATUS.PROCESSING)
  );
}

/** AI savollarni tuzdi, lekin bizga yubora olmadi (masalan, AI'da manzil/login sozlanmagan) */
export function isAiJobDeliveryFailed(job: AiTestJob): boolean {
  return (
    !job.received_at &&
    job.status !== AI_JOB_STATUS.FAILED &&
    job.delivery_status === AI_DELIVERY_STATUS.FAILED
  );
}

/** Savollar kelib saqlangan */
export function isAiJobReceived(job: AiTestJob): boolean {
  return !!job.received_at && job.status !== AI_JOB_STATUS.FAILED;
}

/** `aiTests.status.*` kaliti */
export function aiJobStatusKey(job: AiTestJob): string {
  if (isAiJobReceived(job)) return 'received';
  if (isAiJobMisdelivered(job)) return 'misdelivered';
  if (isAiJobDeliveryFailed(job)) return 'deliveryFailed';
  return job.status;
}

export function aiJobTone(key: string): string {
  switch (key) {
    case 'received':
      return 'badge--success';
    case AI_JOB_STATUS.FAILED:
    case 'deliveryFailed':
      return 'badge--danger';
    case 'misdelivered':
      return 'badge--warning';
    case AI_JOB_STATUS.COMPLETED:
      return 'badge--brand';
    default:
      return 'badge--info';
  }
}

/** AI jarayonida xato bo'ldimi — matni ko'rsatilmaydi, faqat umumiy xabar */
export function isAiJobFailed(job: AiTestJob, refreshError: string | null): boolean {
  return (
    !!refreshError ||
    job.status === AI_JOB_STATUS.FAILED ||
    isAiJobMisdelivered(job) ||
    isAiJobDeliveryFailed(job)
  );
}
